import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [setVisible]);

  if (location.pathname === "/contact" || location.pathname.startsWith("/admin")) return null;

  return (
    <div
      data-testid="sticky-mobile-cta"
      className={`md:hidden fixed bottom-0 inset-x-0 z-50 transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="bg-[#070908]/95 backdrop-blur-md border-t border-border px-4 py-3 flex items-center gap-3">
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold text-foreground truncate">Ready to hire smarter?</p>
          <p className="text-[11px] text-white/55 truncate">Free hiring strategy session</p>
        </div>
        <Link
          to="/contact"
          data-testid="sticky-cta-button"
          className="shrink-0 inline-flex items-center gap-1 px-4 py-2.5 rounded-md text-sm font-semibold bg-[#E45E3B] text-white hover:bg-[#c84d2e] transition-colors"
        >
          Talk to Us
          <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
